import { PeriodUnit } from './enums/PeriodUnit'
import RelativeDurationPeriodJson from './interfaces/RelativeDurationPeriod.json'
import { Duration } from 'luxon'

export default class RelativeDurationPeriod {
  unit: PeriodUnit
  amount: number

  constructor(unit: PeriodUnit, amount: number) {
    this.unit = unit
    this.amount = amount
  }

  toLuxonDuration(): Duration {
    const object: Record<PeriodUnit, number> = {} as Record<PeriodUnit, number>
    object[this.unit] = this.amount

    return Duration.fromObject(object)
  }

  static fromJson(data: RelativeDurationPeriodJson) {
    return new this(data.unit, data.amount)
  }
}
